export class ClassReport {
  ClassID: number;
  CourseCode: string;
  TeacherID?: number;
  TeacherName?: string;
  MissedSkills: ClassReportMissedSkill[];
  Students: ClassReportStudent[];
  StartingOn: string;
  Ending: string;
}

export class ClassReportMissedSkill {
  UnitNumber: number;
  SkillType: string;
  SkillConcept: string;
  Missed: number;
  CourseCode: string;
  Students: string[];
}

export class ClassReportStudent {
  StudentID: number;
  StudentName: string;
  CurrentCourse: string;
  CurrentUnit: number;
  FurthestUnit: number;
  LastLogin: string;
  TimeInCourse: number;
  TimeInAllCourses: number;
  SpeakingOpportunities: number;
  UnitTestCorrect: number;
  UnitTestTotal: number;
}
